module.exports = __webpack_public_path__ + "img/f_25_08.0b8ef12a.jpg";